import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'pos-meal-radio-group',
  templateUrl: './meal-radio-group.component.html',
  styleUrls: ['./meal-radio-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MealRadioGroupComponent
  implements OnInit, ControlValueAccessor, AfterViewInit
{
  @Input()
  set currentMeal(value: number) {
    this.MEAL_OPTIONS = this.MEAL_OPTIONS.map((meal) => {
      if (typeof value === 'undefined') {
        meal.disabled = false;
      } else if (value === null) {
        meal.disabled = true;
      } else {
        meal.disabled = meal.id < value;
      }
      return meal;
    });
    if (!this.value || !value) {
      return;
    }
    if (this.value < value) {
      this.onInputSelected(null);
    }
  }

  MEAL_OPTIONS = [
    { id: 1, name: 'Breakfast', disabled: false },
    { id: 3, name: 'Lunch', disabled: false },
    { id: 5, name: 'Dinner', disabled: false }
  ];

  value!: number;

  // used to display error
  public formControl = new FormControl('');
  readonly faCheckCircle = faCheckCircle;

  constructor(public ngControl: NgControl) {
    ngControl.valueAccessor = this;
  }

  ngOnInit() {}

  public ngAfterViewInit(): void {
    // syncing with validators on host element
    this.formControl = this.ngControl.control as FormControl;
  }

  public onInputSelected(value: number) {
    this.value = value;
    this.onChange(this.value);
    this.onTouched();
  }

  public onBlur() {
    this.onTouched();
  }

  public writeValue(value: number) {
    this.value = value;
  }

  public registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  public registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  private onTouched = () => {};
  touched = false;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private onChange = (_value: number) => {};

  setDisabledState(isDisabled: boolean) {
    if (isDisabled) {
      this.MEAL_OPTIONS = this.MEAL_OPTIONS.map((meal) => {
        meal.disabled = true;
        return meal;
      });
    }
  }
}
